import { Doughnut } from 'react-chartjs-2';
import React from 'react';

import { DougnutComponentProps } from '../types';

export const DougnutComponent: React.FC<Omit<DougnutComponentProps , 'type'>> = (props) => {
    const {
        data,
        chartProps
    } = props;
    return (
        <Doughnut
            {...(chartProps || {} )}
            data={data}
        />
    );
};